import React, { Component } from "react";
import {
  Tree,
  Button,
  Input,
  Pagination,
  message,
  Empty
} from "antd";
import IndexLinkList from "../components/indexLink/indexLinkList";
import AddIndexLink from "../components/indexLink/AddIndexLink";
import {
  indexLinkList,
  delList,
  editData,
} from "../../actions/convergenceMedia";
import { Scrollbars } from "react-custom-scrollbars";
import { HEADER_HEIGHT } from "../../constants";
import * as utils from "../../utils/index";
import "antd/dist/antd.css";
import { edit } from "../changePasswordPolicy/ChangePasswordPolicy";

class IndexLink extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNo: 1,
      limit: 10,
      dataList: [],
      listTotal: 0,
    };
  }
  componentDidMount() {
    this.pageChange();
  }

  // 新增链接
  addST() {
    let url = "/cm-sites/pms/mediaFusion/homeLinkEdit.html";
    window.layer.open({
      title: "新增链接",
      type: 2,
      content: url,
      area: ["700px", "430px"],
      resize: true,
    });
  }

  render() {
    let newSecondSelectColor =
      this.props.config && this.props.config.getValueByKey
        ? this.props.config.getValueByKey("newSecondSelectColor", "#0050B3")
        : "#0050B3";
    let height = window.innerHeight - HEADER_HEIGHT; //上部分70//
    return (
      <div>
        <div
          style={{
            backgroundColor: "#fff",
            marginTop: "15px",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              paddingTop: "15px",
              marginLeft: "15px",
              paddingBottom: "10px",
              borderBottom: "1px solid #f6f6f6",
            }}
          >
            <Button
              style={{
                borderColor: newSecondSelectColor,
                color: newSecondSelectColor,
              }}
              onClick={this.addIndexLink}
            >
              新增链接
            </Button>
          </div>
          {/* 新增链接 */}
          <AddIndexLink ref="AddIndexLink" />
          <div
            style={{
              width: "100%",
              marginLeft: "10px",
              marginRight: "20px",
            }}
          >
            <table
              style={{
                border: "1px solid #666",
                marginTop: "10px",
                textAlign: "center",
              }}
            >
              <thead>
                <tr
                  style={{
                    border: "1px solid #e6e6e6",
                    height: "35px",
                    lineHeight: "35px",
                  }}
                >
                  <td style={{ width: "316px" }}>图标</td>
                  <td style={{ width: "316px" }}>链接名称</td>
                  <td style={{ width: "316px" }}>链接地址</td>
                  <td style={{ width: "316px" }}>状态</td>
                  <td style={{ width: "316px" }}>创建时间</td>
                  <td style={{ width: "316px" }}>操作</td>
                </tr>
              </thead>
            </table>
            {/* 处理滚动条的方法以及自适应 */}
            <div style={{ height: height - 175, background: "white", width: "100%" }}>
              <Scrollbars ref={(Scrollbars) => (this.scrollRef = Scrollbars)}>
                {/* 循环组件 */}
                {
                  this.state.dataList.length === 0 ? <Empty style={{ position: "absolute", top: "45%", left: "45%" }} /> : null
                }
                {this.state.dataList &&
                  this.state.dataList.map((item, index) => {
                    return (
                      <IndexLinkList
                        newSecondSelectColor={newSecondSelectColor}
                        key={index}
                        urlPic={item.urlPic}
                        urlName={item.urlName}
                        urlAddress={item.urlAddress}
                        urlStatus={item.urlStatus}
                        id={item._id}
                        changeDate={
                          item.changeDate && item.changeDate.time
                            ? utils.formatDate(item.changeDate.time) //转化时间
                            : ""
                        }
                        createBy={item.createBy}
                        createTime={
                          item.createTime && item.createTime.time
                            ? utils.formatDate(item.createTime.time) //转化时间
                            : ""
                        }
                        // createTime={
                        //     item.createTime.formatDate("YYYY-MM-dd hh:mm:ss") //转化时间
                        // }
                        createTime={
                          item.createTime && item.createTime
                            ? utils.formatDate(item.createTime) //转化时间
                            : ""
                        }
                        getEditUpdateData={(edit) => this.getEditUpdateData(edit)}
                        del={() => this.del(item._id)}
                      />
                    );
                  })}
              </Scrollbars>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "20px",
                marginBottom: "30px",
                marginRight: "30px"
              }}
            >
              <Pagination
                hideOnSinglePage={true}
                showQuickJumper
                current={this.state.pageNo}
                pageSize={this.state.limit}
                total={this.state.listTotal}
                showTotal={(total) => `共 ${total} 条`}
                showSizeChanger
                onChange={(page, pageSize) => this.onChange(page, pageSize)} //页码改变时回调
                onShowSizeChange={(page, pageSize) => {
                  this.onChange(page, pageSize); //每页条数改变回调
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
  addIndexLink = () => {
    // this.refs.AddIndexLink.showModal();
    this.addST();
  };
  // 删除
  del(id) {
    console.log(id)
    this.delLists(id);
  };
  delLists(delid) {
    console.log(delid)
    let params = {
      id: delid,
    };
    delList(params, (res) => {
      console.log(res);
      if (res) {
        message.success("删除成功");
        this.pageChange();
      } else {
        message.error("删除失败");
      }
    });
  }

  // 页面改变时回调
  onChange(page, pageSize) {
    // 放入变量中
    this.state.pageNo = page;
    this.state.limit = pageSize;
    // 每次改变页码时
    this.pageChange();
  }
  pageChange() {
    let params = {
      pageNo: this.state.pageNo,
      limit: this.state.limit,
      status: 0
    }
    indexLinkList(params, (res) => {
      let dataList = [];
      let listTotal = 0; //列表总数
      if (res && res.data) {
        dataList = res.data;
        listTotal = res.count;
      }
      this.setState({
        dataList: dataList,
        listTotal: listTotal,
      });
    });
  }
  //   编辑获取数据
  getEditUpdateData(edit) {
    let params = {
      changeDate: edit.changeDate,
      createBy: edit.createBy,
      createTime: edit.createTime,
      urlAddress: edit.urlAddress,
      urlName: edit.urlName,
      urlPic: edit.urlPic,
      urlStatus: edit.urlStatus,
      _id: edit.id,
    };
    editData(params, (res) => {
      if (res.data === "修改成功") {
        message.success("修改成功");
        this.pageChange();
      } else {
        message.error("修改失败");
      }
    });
  }
}

export default IndexLink;
